import { render, staticRenderFns } from "./SeasonTicketRevisionsTable.vue?vue&type=template&id=739df612&scoped=true&"
import script from "./SeasonTicketRevisionsTable.vue?vue&type=script&lang=js&"
export * from "./SeasonTicketRevisionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739df612",
  null
  
)

export default component.exports